// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-parent {
    display: grid;
    grid-template-columns: minmax(175px, auto) 1fr;
}

.card {
    height: 20px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
    background-color: #fff;
    font-family: "Nunito Sans", Sans-serif, serif;
    border: solid 1px #afafaf;
    border-radius: 5px;
    margin-right: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    display: flex;
    white-space: nowrap;
    grid-template-columns: auto repeat(2, min-content);
    grid-template-rows: repeat(1, min-content);
    align-items: center;
}

.card span {
    text-indent: 0.5rem;
}

.text {
    color: black;
    font-size: 16px;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}

.size {
    color: #757575;
    font-weight: bold;
    font-size: 14px;
}

.image {
    margin-bottom: -5px;
    text-indent: 0rem;
}

.image:hover {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/form/css/selected-file-component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,sBAAsB;IACtB,6CAA6C;IAC7C,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".card-parent {\n    display: grid;\n    grid-template-columns: minmax(175px, auto) 1fr;\n}\n\n.card {\n    height: 20px;\n    padding-right: 10px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    justify-content: center;\n    background-color: #fff;\n    font-family: \"Nunito Sans\", Sans-serif, serif;\n    border: solid 1px #afafaf;\n    border-radius: 5px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    display: flex;\n    white-space: nowrap;\n    grid-template-columns: auto repeat(2, min-content);\n    grid-template-rows: repeat(1, min-content);\n    align-items: center;\n}\n\n.card span {\n    text-indent: 0.5rem;\n}\n\n.text {\n    color: black;\n    font-size: 16px;\n    align-items: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n}\n\n.size {\n    color: #757575;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.image {\n    margin-bottom: -5px;\n    text-indent: 0rem;\n}\n\n.image:hover {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
